import api from "./api";



const search=async( searchText,companyCode,searchType) =>{
	
	const apiPath = `/search/find?searchText=${searchText}&companyCode=${companyCode}&searchType=${searchType}`;
	console.log("search " );
	const response = api.get(apiPath);
	return response;	
}


const SearchService = {
	search,	
};

export default SearchService;
